export default "__VITE_ASSET__YR4mm221GKPbwdJSn5Ca3g__"